module.exports = __webpack_public_path__ + "img/icon_MyAchievement2.45843d24.svg";